import axios from 'axios'
import { AdminLoginInterface } from '@/types/admin'

export const adminLoginAPI = (form: AdminLoginInterface) => {
  return axios.post(`${process.env.REACT_APP_FETCH_URL}/manager/login`, {
    ...form,
  })
}
